import React from 'react';
import { Link } from 'react-router-dom';
import './Company.css';

const Company: React.FC = () => {
  const history = [
    { year: '1997', event: '천일복합물류 설립' },
    { year: '2000', event: '천일국제물류 법인설립' },
    { year: '2001', event: 'Forwarder 등록' },
    { year: '2004', event: '(주)천일국제보세창고 법인설립' },
    { year: '2006', event: '제1창고 오픈' },
    { year: '2019', event: '제2창고 오픈' }
  ];

  const vision = {
    title: '비전',
    content: '글로벌 물류 혁신을 선도하는 아시아 최고의 종합 물류 기업.',
    missionTitle: '미션',
    mission: '고객의 성공을 위한 최적의 물류 솔루션 제공.',
    coreValuesTitle: '핵심가치',
    coreValues: ['전문성', '신뢰', '혁신', '상생'],
    strategyTitle: '전략',
    strategy: '23년간 축적된 물류 전문 노하우를 바탕으로 최고 수준의 원스톱 서비스를 제공합니다.'
  };

  const organization = {
    ceo: '대표이사',
    teams: [
      {
        title: '지원1팀',
        items: ['수출입컨설팅', '식품검역', '축산검역', '기타검역', '공산품 요건확인', '업무지원']
      },
      {
        title: '지원2팀',
        items: ['통관업무', 'FTA업무', '수출입 업무컨설팅', '기타']
      },
      {
        title: '물류사업팀',
        items: ['화물입출고관리', '입출고관리', '재고관리', '기타']
      },
      {
        title: '운송사업팀',
        items: ['배차', '차량관리', '기타']
      },
      {
        title: '해외사업팀',
        items: ['수출입', '수입 및 수출', '수출입 대행', '기타']
      },
      {
        title: '재무팀',
        items: ['화계관리', '세무, 화계관리', '운영관리', '영업지원업무']
      },
      {
        title: '부산지사',
        items: ['수출입컨설팅', '식품검역', '축산검역', '공산품 요건확인', '업무지원']
      },
      {
        title: '미주법인(LA)',
        items: ['수출입지원', '신규사업', '기타']
      }
    ]
  };

  const partners = {
    stats: [
      { number: '70+', label: '파트너사' },
      { number: '300+', label: '도시 연결' },
      { number: '50+', label: '국가 서비스' },
      { number: '24/7', label: '운영 지원' }
    ]
  };

  const offices = [
    {
      title: '본사',
      address: '경기도 성남시 분당구 야탑로 103, 304호',
      phone: '031-707-7200',
      fax: '031-709-8213',
      email: 'khb@chunilkor.co.kr'
    },
    {
      title: '제1창고',
      address: '경기도 평택시 포승읍 평택항로 95',
      phone: '031-683-7040',
      fax: '031-683-7044',
      email: 'khb@chunilkor.co.kr'
    },
    {
      title: '제2창고',
      address: '경기도 평택시 포승읍 포승산단로 42번길 54',
      phone: '031-691-1001',
      fax: '031-681-1600',
      email: 'khb@chunilkor.co.kr'
    },
    {
      title: '부산지사',
      address: '부산시 중구 중앙대로 26 와전빌딩 6층',
      phone: '051-469-1171',
      fax: '051-469-2171',
      email: 'khb@chunilkor.co.kr'
    }
  ];

  return (
    <div className="company-page">
      <section className="page-hero">
        <div className="container">
          <h1 className="page-title">회사소개</h1>
          <p className="page-subtitle">
            (주)천일국제물류를 찾아주신 고객 여러분께 깊이 감사드립니다.
          </p>
          <div className="hero-cta">
            <Link to="/contact" className="btn btn-secondary">
              견적 요청하기
            </Link>
          </div>
        </div>
      </section>

      {/* 인사말 */}
      <section className="greeting-section">
        <div className="container">
          <h2 className="section-title">인사말</h2>
          <div className="greeting-content">
            <p className="greeting-highlight">
              (주)천일국제물류를 찾아주신 고객 여러분께 깊이 감사드립니다.
            </p>
            <p>
              저희는 25년 이상 경력을 가진 분야별 전문가들로 구성된 전문 물류기업으로, 국제물류(수출·수입 검역 및 식품 수입 컨설팅), 천일국제보세창고 운영(냉동·냉장·드라이 보관) 등에서 탄탄한 노하우를 바탕으로 성장해왔습니다.
            </p>
            <p>
              급변하는 환경 속에서도 파트너와 사회로부터 신뢰받는 기업이 되기 위해 노력하며, 국내 3PL 및 수입 분야의 종합 전문기업으로 도약하고 있습니다.
            </p>
            <p>
              임직원 모두는 내실 성장과 고객 만족을 최우선 가치로 삼아, 고객 여러분의 든든한 파트너가 되기 위해 최선을 다하겠습니다.
            </p>
            <p className="greeting-signature">
              (주)천일국제물류와 함께 성장하시길 바랍니다.
            </p>
            <p className="greeting-signature-name">– 임직원 일동 –</p>
          </div>
        </div>
      </section>

      {/* 비전 & 미션 */}
      <section className="vision-section">
        <div className="container">
          <div className="vision-strategy">
            <h2 className="strategy-title">{vision.strategyTitle}</h2>
            <p className="strategy-content">{vision.strategy}</p>
          </div>

          <div className="vision-grid">
            <div className="vision-card">
              <h3 className="vision-card-title">{vision.title}</h3>
              <p className="vision-card-content">{vision.content}</p>
            </div>
            <div className="vision-card">
              <h3 className="vision-card-title">{vision.missionTitle}</h3>
              <p className="vision-card-content">{vision.mission}</p>
            </div>
            <div className="vision-card">
              <h3 className="vision-card-title">{vision.coreValuesTitle}</h3>
              <p className="vision-card-content">{vision.coreValues.join(' | ')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* 연혁 */}
      <section className="history-section">
        <div className="container">
          <h2 className="section-title">회사 연혁</h2>
          <div className="history-timeline">
            {history.map((item, index) => (
              <div key={index} className="history-item">
                <div className="history-number">{index + 1}</div>
                <div className="history-content">
                  <div className="history-year">{item.year}</div>
                  <div className="history-event">{item.event}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 조직도 */}
      <section className="organization-section">
        <div className="container">
          <h2 className="section-title">조직도</h2>
          <p className="section-subtitle">25년 한국 원스톱 서비스 선두자 프로들로 구성.</p>

          <div className="organization-chart">
            {/* 대표이사 */}
            <div className="org-ceo">
              <div className="org-ceo-box">
                <h3>(주)천일국제물류</h3>
                <p>{organization.ceo}</p>
              </div>
            </div>

            {/* 연결선 */}
            <div className="org-connector"></div>

            {/* 팀들 */}
            <div className="org-teams">
              <div className="org-teams-row">
                {organization.teams.slice(0, 4).map((team, index) => (
                  <div key={index} className="org-team-card">
                    <h4 className="org-team-title">{team.title}</h4>
                    <ul className="org-team-items">
                      {team.items.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
              <div className="org-teams-row">
                {organization.teams.slice(4, 8).map((team, index) => (
                  <div key={index} className="org-team-card">
                    <h4 className="org-team-title">{team.title}</h4>
                    <ul className="org-team-items">
                      {team.items.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 파트너 */}
      <section className="partners-section">
        <div className="container">
          <h2 className="section-title">파트너</h2>
          <p className="section-subtitle">전 세계 우수한 물류 파트너들과 함께 고객에게 최고의 물류 서비스를 제공합니다.</p>

          <div className="partners-stats">
            {partners.stats.map((stat, index) => (
              <div key={index} className="partner-stat">
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 찾아오시는 길 */}
      <section className="location-section">
        <div className="container">
          <h2 className="section-title">찾아오시는 길</h2>
          <div className="offices-grid">
            {offices.map((office, index) => {
              // 각 사무실의 구글맵 주소
              const mapUrls = [
                'https://maps.google.com/maps?q=경기도+성남시+분당구+야탑로+103&output=embed',
                'https://maps.google.com/maps?q=경기도+평택시+포승읍+평택항로+95&output=embed',
                'https://maps.google.com/maps?q=경기도+평택시+포승읍+포승산단로+42번길+54&output=embed',
                'https://maps.google.com/maps?q=부산시+중구+중앙대로+26+와전빌딩&output=embed'
              ];

              return (
                <div key={index} className="office-card">
                  {/* 정보 */}
                  <div className="office-info-section">
                    <h3 className="office-title">{office.title}</h3>
                    <div className="office-info">
                      <p><strong>주소:</strong> {office.address}</p>
                      <p><strong>전화:</strong> {office.phone}</p>
                      <p><strong>팩스:</strong> {office.fax}</p>
                      <p><strong>이메일:</strong> {office.email}</p>
                    </div>
                  </div>

                  {/* 구글 지도 */}
                  <div className="office-map">
                    <iframe
                      src={mapUrls[index]}
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title={`${office.title} 지도`}
                    ></iframe>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Company;
